import React, { useState, useCallback } from 'react';
import { ErrorState } from './Errors';
import { Spinner } from '@blueprintjs/core';

export default function Managed({ state, children }) {
  if (state.status === 'init') {
    return <Spinner />;
  }
  if (state.status === 'error') {
    return <ErrorState errors={state.errors} />;
  }
  return children;
}

export function useManaged(defaultValue = null) {
  const [state, setState] = useState({
    status: 'init',
    data: defaultValue,
    errors: [],
  });
  const setStateError = useCallback(
    (exception) => {
      try {
        if (!exception.response.data.errors) {
          throw new Error('no errors!');
        }
        setState({
          status: 'error',
          data: defaultValue,
          errors: exception.response.data.errors,
        });
      } catch (e) {
        setState({
          status: 'error',
          data: defaultValue,
          errors: [{ title: exception.message }],
        });
      }
    },
    [defaultValue]
  );
  const setStateData = useCallback(
    (data) => {
      if (typeof data === 'function') {
        setState((state) => ({
          status: 'ready',
          data: data(state.data || {}),
        }));
      } else {
        setState({
          status: 'ready',
          data,
        });
      }
    },
    [setState]
  );
  return [state, setStateData, setStateError];
}
